
const heyCoachApiUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : 'https://heycoach-rest-webapp.onrender.com';
const streamChatEnv = process.env.NODE_ENV === 'development' ? 'dev' : 'prod';

export {
    heyCoachApiUrl,
    streamChatEnv,
}